import { Badge, Dropdown } from "react-bootstrap";
import {
  formatContentDate,
  getThemeColors,
} from "../../utils/content.utils";

const ColorSwatch = ({ color, label }) => {
  if (!color) return null;
  return (
    <span
      title={`${label}: ${color}`}
      style={{
        display: "inline-block",
        width: 14,
        height: 14,
        borderRadius: 3,
        backgroundColor: color,
        border: "1px solid rgba(0,0,0,0.15)",
        marginRight: 4,
        verticalAlign: "middle",
      }}
    />
  );
};

const ThemePreview = ({ content }) => {
  const theme = getThemeColors(content);
  if (!theme) return <span className="text-muted">—</span>;

  return (
    <span className="d-inline-flex align-items-center flex-wrap gap-1">
      <ColorSwatch color={theme.primaryColor} label="Primary" />
      <ColorSwatch color={theme.secondaryColor} label="Secondary" />
      <ColorSwatch color={theme.textColor} label="Text" />
      <ColorSwatch color={theme.buttonHoverColor} label="Button hover" />
    </span>
  );
};

const ContentsTable = ({ items, onEdit, canManage }) => {
  return (
    <div className="table-responsive">
      <table className="table table-striped mb-0">
        <thead>
          <tr>
            <th style={{ width: 48 }}>#</th>
            <th style={{ minWidth: 160 }}>Name</th>
            <th style={{ width: 100 }}>Type</th>
            <th style={{ width: 110 }}>Sections</th>
            <th style={{ minWidth: 140 }}>Theme</th>
            <th style={{ minWidth: 150 }}>Updated</th>
            <th className="text-center" style={{ width: 72 }}>
              Actions
            </th>
          </tr>
        </thead>
        <tbody>
          {items.map((item, index) => {
            const isTheme = item.kind === "theme";

            return (
              <tr key={item.key || `content-item-${index}`}>
                <td>{index + 1}</td>
                <td className="fw-medium">{item.label}</td>
                <td>
                  <Badge bg={isTheme ? "info" : "secondary"}>
                    {isTheme ? "Theme" : "Page"}
                  </Badge>
                </td>
                <td>
                  {isTheme ? (
                    <span className="text-muted">—</span>
                  ) : (
                    item.sectionCount ?? 0
                  )}
                </td>
                <td>
                  {isTheme ? (
                    <ThemePreview content={item.content} />
                  ) : (
                    <span className="text-muted">—</span>
                  )}
                </td>
                <td>{formatContentDate(item.updated_at)}</td>
                <td className="text-center align-middle">
                  <Dropdown>
                    <Dropdown.Toggle
                      variant="link"
                      className="p-0 text-decoration-none"
                    >
                      &#x2022;&#x2022;&#x2022;
                    </Dropdown.Toggle>
                    <Dropdown.Menu align="end">
                      <Dropdown.Item
                        onClick={() => onEdit(item)}
                        disabled={!item.contentId || !item.focusId || !canManage}
                      >
                        Edit
                      </Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default ContentsTable;
